
























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { IColumnHeader, AVAILABLE_FIELDS_TRACK_SELECTOR, TrackFields } from '@/constants'
import { durationSecondsValueGetter, ratingValueGetter, sizeValueGetter, fileTypeValueGetter } from '@/helpers/ag-grid/valueGetter'
import { durationSecondsComparator, ratingComparator, colorComparator, dateComparator } from '@/helpers/ag-grid/comparator'
import { ratingCellRenderer, colorCellRenderer, dateCellRenderer } from '@/helpers/ag-grid/cellRenderer'
import { IColumnDef } from '../../interfaces/ag-grid'
const AgGridVue = () => import(`@/modules/ag-grid`)

function moveInArray(arr: any[], fromIndex: number, toIndex: number) {
  const element = arr[fromIndex]
  arr.splice(fromIndex, 1)
  arr.splice(toIndex, 0, element)
}

@Component({
  components: {
    AgGridVue,
    ColumnVisibility: require('./ColumnVisibility').default,
    CopyTextModal: require('@/components/CopyTextModal').default,
    TrackFieldEditorModal: require('@/components/TrackFieldEditorModal').default,
    TrackDeleteModal: require('./TrackDeleteModal').default
  }
})
export default class ReorderTable extends Vue {
  @Prop({
    default: '800px'
  })
  height: string

  @Prop()
  nextFunction: Function

  @Prop()
  prevFunction: Function

  @Prop({
    default: 'Continue'
  })
  nextLabel: string

  @Prop({
    default: 'Back'
  })
  prevLabel: string

  @Prop()
  nextDisabled: boolean

  @Prop({
    default: true
  })
  allowNextForDemo: boolean

  @Prop()
  loading: boolean

  @Prop()
  columns: IColumnHeader[] // Emit when order or visibility changed, these arent columnDefs

  @Prop()
  tracks: Track[]

  @Prop({
    default: false
  })
  showShareButton: boolean

  @Prop({
    default: true
  })
  allowDrag: boolean

  @Prop({
    default: false
  })
  allowSelection: boolean

  @Prop()
  localStorageString: string

  @Prop()
  columnDefs: IColumnDef[]

  @Prop()
  selectedTracks: Track[]

  @Prop()
  hideColumnVisibility: boolean

  @Prop({
    default: true
  })
  showSearch: boolean

  @Prop({
    default: true
  })
  allowSort: boolean

  @Prop()
  selectedIndexes: number[] // Not yet initialized

  @Prop({
    default: false
  })
  showFieldEditButton: boolean

  @Prop({
    default: false
  })
  showDeleteButton: boolean

  gridApi: any
  columnApi: any
  columnDefsModel: IColumnDef[]
  originalColumnDefsValues: string[] = []
  sortActive: boolean = false
  tracksModel: Track[] = this.tracks
  quickFilterModel: string | null = null
  loaded: boolean = false // Short fade-in otherwise you see all columns build up which is ugly

  selectionInitialized: boolean = false

  visibleColumns: IColumnHeader[] = [] // AVAILABLE_FIELDS_TRACK_SELECTOR.filter(x => x.visible)

  defaultColumnDef = {
    sortable: true,
    resizable: true,
    filter: false // No filtering allowed in this table. Makes drag&drop very difficult and since this table mirrors the result, user should always see the end result
  }

  onGridReady(params: any) {
    this.selectionInitialized = false

    this.gridApi = params.api
    this.columnApi = params.columnApi

    this.gridApi.cacheQuickFilter = true

    let columnsString: string | null = null

    if (this.localStorageString) {
      columnsString = localStorage.getItem(this.localStorageString)
    }

    if (columnsString) {
      const columns = JSON.parse(columnsString)

      this.columnApi.setColumnState(columns)

      const visibleColumns: IColumnHeader[] = []
      columns.forEach((col: any) => {
        const visibleCol = AVAILABLE_FIELDS_TRACK_SELECTOR.find(x => x.value === col.colId)

        if (visibleCol && !col.hide) {
          visibleCol.visible = true
          visibleColumns.push(visibleCol)
        }
      })

      this.updateColumnVisibility(visibleColumns)

      if (!this.hideColumnVisibility) {
        (this.$refs.colvis as any).updateSelected(visibleColumns)
      }
    } else {
      if (this.columnDefs) {
        const visibleColumns: IColumnHeader[] = []

        for (const fieldName of this.originalColumnDefsValues) {
          const a = AVAILABLE_FIELDS_TRACK_SELECTOR.find(x => x.value === fieldName)

          if (a) {
            visibleColumns.push(a)
          } else {
            const b = this.columnDefs.find(x => x.field === fieldName)

            if (b) {
              visibleColumns.push({
                label: b.field,
                value: b.field,
                visible: true
              })
            }
          }
        }

        this.updateColumnVisibility(visibleColumns)

        if (!this.hideColumnVisibility) {
          (this.$refs.colvis as any).updateSelected(visibleColumns)
        }
      } else {
        this.updateColumnVisibility(AVAILABLE_FIELDS_TRACK_SELECTOR.filter(x => x.visible))
      }
    }

    if (this.allowSelection && this.selectedTracks) {
      if (this.tracks.length === this.selectedTracks.length) {
        this.gridApi.selectAll()
      } else {
        this.selectedTracks.forEach((t: Track) => { // TODO: this can get quite slow with many rows selected, need some kind of bulk select here that doesnt update UI until its done
          const node = this.gridApi.getRowNode(t._id)

          if (node) node.setSelected(true)
        })
      }

      setTimeout(() => { // Node selection is apparently async so wait a bit before allowing onSelectionChanged events to happen
        this.selectionInitialized = true
      }, 100)
    }

    this.loaded = true
  }

  onTrackEditModalOpen() {
    this.removeEventListeners()
  }

  onTrackEditModalClose() {
    this.addEventListeners()
  }

  onTrackEditModalSave() {
    this.gridApi.deselectAll()
  }

  onCellClicked(e: { colDef: IColumnDef, value: any, type: string}) {
    if (e.colDef.field === TrackFields.Location) {
      window.location.href = 'rekordcloud://showfileinfolder_' + encodeURIComponent(e.value)
    }
  }

  onSelectionChanged() {
    if (!this.selectionInitialized) return

    const nodes: {
      rowIndex: number
      data: Track
    }[] = this.gridApi.getSelectedNodes()

    this.$emit('update:selectedTracks', nodes.map(x => x.data))
    this.$emit('update:selectedIndexes', nodes.map(x => x.rowIndex))
  }

  onRowDragEnd() {
    this.emitTracks()
  }

  onSortChanged() {
    const sortModel = this.gridApi.getSortModel()
    this.sortActive = sortModel && sortModel.length > 0
    const suppressRowDrag = this.sortActive

    this.gridApi.setSuppressRowDrag(suppressRowDrag)

    this.emitTracks()
  }

  onRowDragMove(event: any) {
    const movingNode = event.node
    const overNode = event.overNode
    const rowNeedsToMove = movingNode !== overNode

    if (!overNode) return

    if (rowNeedsToMove) {
      const movingData = movingNode.data
      const overData = overNode.data
      const fromIndex = this.tracksModel.indexOf(movingData)
      const toIndex = this.tracksModel.indexOf(overData)
      const newStore = this.tracksModel.slice()

      moveInArray(newStore, fromIndex, toIndex)

      this.tracksModel = newStore
      this.gridApi.clearFocusedCell()
    }
  }

  onColumnDragStopped() {
    this.saveColumnState()
  }

  emitTracks() {
    let tracksOrdered: Track[] = []

    if (this.gridApi) {
      const nodesOrdered: any[] = []

      this.gridApi.forEachNode((x: any) => nodesOrdered.push((x)))

      nodesOrdered.sort((a, b) => a.childIndex - b.childIndex)

      tracksOrdered = nodesOrdered.map(x => x.data)
    } else {
      tracksOrdered = this.tracksModel
    }

    this.$emit('update:tracks', tracksOrdered)
  }

  clearFilters() {
    this.quickFilterModel = null
    this.gridApi.setFilterModel(null)
  }

  autofitColumns() {
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit()
    }
  }

  updateColumnVisibility(columns: IColumnHeader[] | string[]) {
    if (!this.columnApi) return

    for (const col of this.columnApi.getAllColumns()) {
      if (this.columnDefs && !this.originalColumnDefsValues.includes(col.colId)) {
        this.columnApi.setColumnVisible(col.colId, false)
      }
    }

    for (const v of columns) {
      if ((v as IColumnHeader).value) {
        this.columnApi.setColumnVisible((v as IColumnHeader).value, (v as IColumnHeader).visible)
      } else {
        this.columnApi.setColumnVisible(v, true)
      }
    }

    this.gridApi.sizeColumnsToFit()

    this.$emit('update:columns', columns)

    this.saveColumnState()
  }

  updateColumnDefs(columns: IColumnDef[] = this.columnDefsModel) {
    if (this.gridApi) {
      this.gridApi.setColumnDefs([]) // Prevents new colDef ID's getting suffixed with _1
      this.gridApi.setColumnDefs(columns)
    }

    this.updateColumnVisibility(this.columnDefs.map(c => c.field))

    if (!this.hideColumnVisibility) { // TODO: this does not yet function correctly with dynamic columns (bulk editor)
      (this.$refs.colvis as any).updateSelected(this.columnDefs.map(c => {
        return {
          label: c.headerName,
          value: c.field,
          visible: true
        } as IColumnHeader
      }))
    }

    this.autofitColumns()
  }

  saveColumnState() {
    if (this.localStorageString) {
      localStorage.setItem(this.localStorageString, JSON.stringify(this.columnApi.getColumnState()))
    }
  }

  share() {
    (this.$refs.copyTextModal as any).openModal()
  }

  initializeColumns() {
    this.columnDefsModel = [ // Defaults
      {
        field: TrackFields.Title,
        rowDrag: this.allowDrag,
        checkboxSelection: this.allowSelection,
        headerCheckboxSelection: this.allowSelection
      },
      {
        field: TrackFields.Artist,
        width: 150
      },
      {
        field: TrackFields.Album,
        width: 150
      },
      {
        field: TrackFields.BPM,
        filter: 'agNumberColumnFilter',
        width: 80
      },
      {
        field: TrackFields.Key,
        width: 80
      },
      {
        field: TrackFields.Duration,
        filter: false, // Its a string and greater than doesnt work on that so just hide it for now
        valueGetter: durationSecondsValueGetter,
        comparator: durationSecondsComparator
      },
      {
        field: TrackFields.Rating,
        valueGetter: ratingValueGetter,
        comparator: ratingComparator,
        cellRenderer: ratingCellRenderer
      },
      {
        field: TrackFields.Bitrate,
        filter: 'agNumberColumnFilter'
      },
      {
        field: TrackFields.PlayCount,
        filter: 'agNumberColumnFilter'
      },
      {
        field: TrackFields.Color,
        cellRenderer: colorCellRenderer,
        comparator: colorComparator
      },
      {
        field: TrackFields.SizeBytes,
        valueGetter: sizeValueGetter
      },
      {
        field: TrackFields.FileType,
        valueGetter: fileTypeValueGetter
      },
      {
        field: TrackFields.DateImported,
        valueGetter: dateCellRenderer,
        comparator: dateComparator
      }
    ]

    if (this.columnDefs) {
      this.columnDefsModel = Object.assign(this.columnDefsModel, this.columnDefs)

      this.originalColumnDefsValues = this.columnDefs.map(c => c.field)

      if (this.allowSelection) {
        const fieldRow = this.columnDefsModel[0]

        if (fieldRow) {
          fieldRow.rowDrag = false
          fieldRow.checkboxSelection = true
          fieldRow.headerCheckboxSelection = true
        }
      }
    }

    for (const t of AVAILABLE_FIELDS_TRACK_SELECTOR) {
      const colDef = this.columnDefsModel.find(x => x.field === t.value)

      if (colDef) {
        colDef.headerName = t.label
      } else {
        this.columnDefsModel.push({
          headerName: t.label,
          field: t.value
        })
      }
    }
  }

  onKeyDown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this.gridApi.deselectAll()
    }
  }

  addEventListeners() {
    window.addEventListener('keydown', this.onKeyDown)
  }

  removeEventListeners() {
    window.removeEventListener('keydown', this.onKeyDown)
  }

  destroyed() {
    this.removeEventListeners()
  }

  created() {
    this.initializeColumns()

    this.addEventListeners()
  }

  @Watch('visibleColumns', { deep: true }) // Updates columns when colvis ref does something
  updateColumns(columns: IColumnHeader[]) {
    this.updateColumnVisibility(columns)
  }

  @Watch('columnDefs')
  watchColumnDefs() {
    this.initializeColumns()

    this.updateColumnDefs()
  }

  @Watch('quickFilterModel')
  updateTableQuickFilter(v: string) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(v)
    }
  }

  @Watch('tracks')
  watchTracks() {
    this.tracksModel = this.tracks
  }

  @Watch('allowDrag')
  watchAllowDrag() {
    this.gridApi.deselectAll()

    const colDef = this.columnDefsModel.find(x => x.field === TrackFields.Title)

    if (colDef) {
      colDef.rowDrag = this.allowDrag
      colDef.checkboxSelection = this.allowSelection
      colDef.headerCheckboxSelection = this.allowSelection
    }

    this.updateColumnDefs(this.columnDefsModel)
  }

  @Watch('selectedTracks')
  watchSelectedTracks() {
    if (this.selectedTracks.length === 0) {
      this.gridApi.deselectAll()
    }
  }
}
